import { Navigate } from "react-router-dom";
import { getUserRole } from "../utils/authToken";

interface Props {
  children: React.ReactNode;
  allowedRoles: string[];
}

const RoleRoute = ({ children, allowedRoles }: Props) => {

  const role = getUserRole();

  if (!role || !allowedRoles.includes(role)) {
    return <Navigate to="/dashboard" />;
  }

  return <>{children}</>;
};

export default RoleRoute;